module.exports = __webpack_public_path__ + "static/media/oeufs.67b13908.svg";